const tabifotoAdmin = {
  tabifotoAdmin: {
    nav: {
      content_section: "コンテンツ管理",
      operations_section: "運営管理",
      dashboard: "ダッシュボード",
      services: "サービス管理",
      portfolio: "ポートフォリオ管理",
      homepage_display: "ホームページ表示設定",
      content: "コンテンツ管理",
      orders: "注文管理",
      photographers: "フォトグラファー管理",
      photographer_applications: "フォトグラファー申請",
      photographer_availability: "空き時間管理",
      booking_confirmations: "予約確認管理",
      legal_documents: "法的書類",
      booking_cost_items: "費用明細",
      booking_notes: "予約メモ",
      order_cancellation_logs: "キャンセル記録",
      order_reschedule_logs: "変更記録",
      relay: "メッセージセンター",
    },
    lang: {
      zh: "中文",
      en: "EN",
      ja: "日本語",
      label: "言語",
    },
    common: {
      save: "変更を保存",
      cancel: "キャンセル",
      add: "追加",
      edit: "編集",
      delete: "削除",
      deactivate: "無効化",
      active: "有効",
      inactive: "無効",
      published: "公開済み",
      draft: "下書き",
      sort_order: "並び順",
      yes: "はい",
      no: "いいえ",
      actions: "操作",
      loading: "読み込み中...",
      error_load: "読み込み失敗。再試行してください。",
      retry: "再試行",
      empty: "データがありません。",
      confirm_delete: "このアイテムを削除しますか？",
      cannot_undone: "この操作は取り消せません。",
      confirm_deactivate: "このアイテムを無効化しますか？",
      deactivate_desc: "レコードは保持されます — is_active が false に設定されます。",
      save_success: "保存しました",
      save_error: "保存に失敗しました。再試行してください。",
      delete_success: "削除しました",
      delete_error: "削除に失敗しました",
      api_not_configured: "API が設定されていません — デモデータを表示中",
    },
    dashboard: {
      title: "ダッシュボード",
      subtitle: "TaBiFoTo CMS — コンテンツと運営管理",
      active_services: "有効なサービス",
      published_portfolio: "公開済み作品",
      on_showreel: "ショーリール掲載",
      featured_works: "注目作品",
      active_content: "有効なコンテンツ",
      service_options: "サービスオプション",
      data_tables: "データテーブル",
      reset_title: "デフォルトにリセット",
      reset_desc: "すべてのデータを初期デモ値に戻します。取り消せません。",
      reset_button: "データをリセット",
      drafts_warning: "{{count}} 件の下書きが未公開",
      inactive_warning: "{{count}} 件のサービスが無効",
    },
    services: {
      title: "サービス管理",
      subtitle: "サービステーブル管理 — 多言語・価格・対応都市・オプション",
      add_service: "サービスを追加",
      edit_service: "サービスを編集",
      col_order: "#",
      col_image: "画像",
      col_code: "コード",
      col_title: "名称（中文）",
      col_price: "価格（台湾ドル）",
      col_hours: "時間",
      col_cities: "対応都市",
      col_active: "有効",
      col_sort: "並び順",
      col_options: "オプション",
      col_actions: "操作",
      service_code: "service_code",
      icon_class: "アイコン Class",
      title_field: "サービス名",
      short_desc: "短い説明",
      features: "特徴リスト",
      add_feature: "+ 特徴を追加",
      base_price: "基本料金（NT$）",
      duration_hours: "所要時間",
      city_scope: "対応都市",
      cover_image: "カバー画像 URL",
      no_options: "オプションがありません。",
      manage_options: "オプション管理",
      add_option: "オプションを追加",
      edit_option: "オプションを編集",
      option_code: "option_code",
      option_title: "オプション名",
      price_delta: "追加料金（NT$）",
      deactivate_confirm: "このサービスを無効化しますか？",
      deactivate_desc: "レコードは保持 — is_active が false に設定されます。",
      opts_label: "{{count}} オプション",
    },
    portfolio: {
      title: "ポートフォリオ管理",
      subtitle: "portfolio_items 管理 — ショーリール・注目・ホームページ表示制御",
      add_item: "作品を追加",
      edit_item: "作品を編集",
      filter_all: "すべて",
      filter_published: "公開済み",
      filter_showreel: "ショーリール",
      filter_featured: "注目",
      col_order: "#",
      col_thumb: "サムネ",
      col_title: "タイトル",
      col_city: "都市",
      col_shoot_type: "撮影タイプ",
      col_showreel: "ショーリール",
      col_featured: "注目",
      col_published: "公開状態",
      col_display_mode: "表示モード",
      col_sort: "並び順",
      col_actions: "操作",
      title_field: "タイトル",
      photographer_id: "フォトグラファー ID",
      city: "都市",
      shoot_type: "撮影タイプ",
      media_type: "メディアタイプ",
      thumbnail_url: "サムネ URL",
      media_url: "メディア URL",
      description: "説明",
      display_mode: "homepage_display_mode",
      no_items: "条件に一致する作品がありません。",
      delete_confirm: "この作品を削除しますか？",
    },
    homepage: {
      title: "ホームページ表示設定",
      subtitle: "ホームページのショーリールと注目セクションに表示する portfolio_items を管理",
      on_showreel: "ショーリール掲載",
      featured_works: "注目作品",
      total_published: "公開済み合計",
      tab_showreel: "ショーリール",
      tab_featured: "注目作品",
      tab_all: "全公開済み",
      is_showreel: "ショーリール",
      is_featured: "注目",
      display_mode: "表示モード",
      sort_order_field: "並び順",
      publish_first: "公開済み作品がありません。先にポートフォリオ管理で公開してください。",
    },
    content: {
      title: "コンテンツ管理",
      subtitle: "Hero テキスト・理念セクション・CTA を編集 — zh / en / ja 対応",
      add_section: "セクションを追加",
      edit_section: "セクションを編集",
      section_key: "section_key",
      image_url: "画像 URL",
      title_field: "タイトル",
      content_field: "コンテンツ",
      no_items: "このセクションにレコードがありません。",
      delete_confirm: "このセクションを削除しますか？",
      records_count: "{{count}} 件",
      hero_label: "Hero",
      hero_desc: "ホームページ Hero の見出し・副見出し・背景画像・CTA テキスト",
      philosophy_label: "理念ページ",
      philosophy_desc: "理念ページの Hero と 4 つのコンテンツセクション",
      cta_label: "CTA ブロック",
      cta_desc: "各ページの CTA タイトルと本文",
    },
    orders: {
      title: "注文管理",
      subtitle: "顧客の予約リクエストを確認・管理 — 注文ステータスと支払いステータスの追跡",
      add_order: "注文を追加",
      edit_order: "注文を編集",
      filter_all: "すべて",
      col_order_number: "注文番号",
      col_customer: "顧客",
      col_city: "都市",
      col_service: "サービス",
      col_shoot_date: "撮影日",
      col_total: "合計",
      col_order_status: "注文ステータス",
      col_payment_status: "支払い",
      col_actions: "操作",
      customer_name: "顧客氏名",
      customer_email: "メールアドレス",
      customer_phone: "電話番号",
      service_id: "サービス",
      selected_city: "都市",
      shoot_date: "撮影日",
      start_time: "開始時間",
      end_time: "終了時間",
      number_of_reels: "リール数",
      subtotal_twd: "小計（NT$）",
      addons_total_twd: "オプション小計（NT$）",
      total_twd: "合計（NT$）",
      currency: "通貨",
      order_status: "注文ステータス",
      payment_status: "支払いステータス",
      special_requests: "特別リクエスト",
      internal_notes: "内部メモ",
      order_status_pending: "保留中",
      order_status_confirmed: "確認済み",
      order_status_cancelled: "キャンセル済み",
      order_status_completed: "完了",
      payment_status_unpaid: "未払い",
      payment_status_paid: "支払い済み",
      payment_status_refunded: "返金済み",
      payment_status_partial: "一部支払い",
      no_orders: "注文がありません。",
      delete_confirm: "この注文を削除しますか？",
      related_records: "関連記録",
      related_cost_items: "費用明細",
      related_notes: "メモ",
      related_cancellations: "キャンセル",
      related_reschedules: "変更",
      view_related: "表示",
    },
    photographers: {
      title: "フォトグラファー管理",
      subtitle: "フォトグラファーの運営情報管理 — ステータス・言語・拠点都市・連絡先",
      add_photographer: "フォトグラファーを追加",
      edit_photographer: "フォトグラファーを編集",
      col_code: "コード",
      col_name: "表示名",
      col_legal_name: "法定氏名",
      col_city_base: "拠点都市",
      col_languages: "言語",
      col_status: "ステータス",
      col_active: "有効",
      col_actions: "操作",
      photographer_code: "photographer_code",
      display_name: "表示名",
      legal_name: "法定氏名",
      email: "メールアドレス",
      phone: "電話番号",
      country_code: "国コード",
      city_base: "拠点都市",
      languages: "言語（カンマ区切り、例: zh,en,ja）",
      status: "ステータス",
      portfolio_url: "ポートフォリオ URL",
      notes: "メモ",
      status_active: "在職中",
      status_inactive: "退職",
      status_on_leave: "休暇中",
      status_suspended: "停止中",
      deactivate_confirm: "このフォトグラファーを無効化しますか？",
      deactivate_desc: "レコードは保持されます — is_active が false に設定されます。",
      no_photographers: "フォトグラファーがいません。",
      all_count: "{{count}} 名",
      gender_label: "性別（マッチング用のみ）",
      gender_note: "このフィールドはマッチングの参考としてのみ使用され、公開フィルターには表示されません。",
      gender_prefer_not_to_say: "非公開",
      gender_male: "男性",
      gender_female: "女性",
    },
    photographer_availability: {
      title: "空き時間管理",
      subtitle: "フォトグラファーの空き時間管理 — 日付・時間・都市・ステータス",
      add_availability: "時間枠を追加",
      edit_availability: "時間枠を編集",
      filter_all: "すべて",
      col_photographer: "フォトグラファー",
      col_date: "日付",
      col_time: "時間枠",
      col_city: "都市",
      col_status: "ステータス",
      col_note: "メモ",
      col_actions: "操作",
      photographer_id: "フォトグラファー",
      available_date: "空き日付",
      available_start_time: "開始時間",
      available_end_time: "終了時間",
      city: "都市",
      status: "ステータス",
      note: "メモ",
      status_available: "予約可能",
      status_booked: "予約済み",
      status_blocked: "不可",
      no_availability: "空き時間の記録がありません。",
      delete_confirm: "この空き時間記録を削除しますか？",
    },
    booking_confirmations: {
      title: "予約確認管理",
      subtitle: "注文に対するフォトグラファーの確認ステータス管理 — 確認・拒否・交代対応",
      add_confirmation: "確認を追加",
      edit_confirmation: "確認を編集",
      filter_all: "すべて",
      col_order: "注文",
      col_photographer: "フォトグラファー",
      col_status: "確認ステータス",
      col_confirmed_at: "確認日時",
      col_replacement: "交代要否",
      col_note: "メモ",
      col_actions: "操作",
      order_id: "注文",
      photographer_id: "フォトグラファー",
      confirmation_status: "確認ステータス",
      confirmed_at: "確認日時",
      declined_at: "拒否日時",
      replacement_required: "フォトグラファーの交代が必要",
      note: "メモ",
      status_pending: "保留中",
      status_confirmed: "確認済み",
      status_declined: "拒否",
      status_replacement_needed: "交代必要",
      no_confirmations: "予約確認記録がありません。",
      delete_confirm: "この確認記録を削除しますか？",
      unassigned: "未割り当て",
    },
    legal_documents: {
      title: "法的書類",
      subtitle: "利用規約・プライバシーポリシー・写真使用許諾書の管理 — 多言語コンテンツ対応",
      add_document: "書類を追加",
      edit_document: "書類を編集",
      filter_all: "すべて",
      col_doc_type: "種類",
      col_doc_key: "Doc Key",
      col_title: "タイトル",
      col_version: "バージョン",
      col_effective_date: "発効日",
      col_active: "有効",
      col_actions: "操作",
      doc_type: "書類の種類",
      doc_key: "Doc Key（システム識別子）",
      title_field: "タイトル",
      content_field: "内容",
      version: "バージョン",
      effective_date: "発効日",
      no_documents: "法的書類がありません。",
      delete_confirm: "この書類を削除しますか？",
      doc_type_terms: "利用規約",
      doc_type_service_agreement: "撮影サービス契約書",
      doc_type_cancellation: "キャンセル・変更ポリシー",
      doc_type_privacy: "プライバシーポリシー",
      doc_type_photo_release: "写真使用許諾書",
      doc_type_photographer_contract: "フォトグラファー業務委託契約",
      doc_type_platform_disclaimer: "プラットフォーム免責事項",
      doc_type_cross_border: "越境サービス利用規約",
    },
    booking_cost_items: {
      title: "費用明細",
      subtitle: "注文ごとの交通・宿泊費用を記録 — キャンセル・返金判断のため不返金費用を管理",
      add_item: "費用を追加",
      edit_item: "費用を編集",
      filter_all: "すべて",
      col_order: "注文",
      col_cost_type: "費用タイプ",
      col_amount: "金額",
      col_currency: "通貨",
      col_cost_status: "ステータス",
      col_description: "説明",
      col_created_at: "作成日",
      col_actions: "操作",
      order_id: "注文",
      cost_type: "費用タイプ",
      amount_twd: "金額（NT$）",
      currency: "通貨",
      cost_status: "費用ステータス",
      description: "説明",
      cost_type_flight: "航空券",
      cost_type_train: "電車",
      cost_type_accommodation: "宿泊",
      cost_type_local_transport: "現地交通",
      cost_type_ticket: "チケット",
      cost_type_other: "その他",
      cost_status_estimated: "見積もり",
      cost_status_booked: "予約済み",
      cost_status_paid: "支払い済み",
      cost_status_non_refundable: "返金不可",
      no_items: "費用明細がありません。",
      delete_confirm: "この費用記録を削除しますか？",
      total_label: "合計",
      non_refundable_warning: "返金不可の費用に注意が必要です",
    },
    booking_notes: {
      title: "予約メモ",
      subtitle: "注文ごとの内部メモ・顧客向け説明・フォトグラファーへの指示を管理",
      add_note: "メモを追加",
      filter_all: "すべて",
      col_order: "注文",
      col_note_type: "種類",
      col_content: "内容",
      col_created_by: "作成者",
      col_created_at: "作成日",
      col_actions: "操作",
      order_id: "注文",
      note_type: "メモ種類",
      content: "内容",
      created_by: "作成者",
      note_type_internal: "内部",
      note_type_customer_visible: "顧客向け",
      note_type_photographer_visible: "フォトグラファー向け",
      no_notes: "予約メモがありません。",
      delete_confirm: "このメモを削除しますか？",
      content_placeholder: "メモ内容を入力...",
    },
    order_cancellation_logs: {
      title: "キャンセル記録",
      subtitle: "注文キャンセルの監査記録 — 返金額・違約金・返金不可費用の内訳",
      add_log: "キャンセル記録を追加",
      edit_log: "キャンセル記録を編集",
      filter_all: "すべて",
      col_order: "注文",
      col_cancelled_at: "キャンセル日時",
      col_cancelled_by: "キャンセル者",
      col_refund: "返金額",
      col_penalty: "違約金",
      col_non_refundable: "返金不可",
      col_actions: "操作",
      order_id: "注文",
      cancelled_at: "キャンセル日時",
      cancelled_by: "キャンセル者",
      reason: "キャンセル理由",
      refund_amount_twd: "返金額（NT$）",
      penalty_amount_twd: "違約金（NT$）",
      non_refundable_cost_twd: "返金不可費用（NT$）",
      note: "メモ",
      no_logs: "キャンセル記録がありません。",
      delete_confirm: "このキャンセル記録を削除しますか？",
      financial_summary: "財務サマリー",
      by_customer: "顧客",
      by_ops: "運営",
    },
    order_reschedule_logs: {
      title: "変更記録",
      subtitle: "注文変更の監査記録 — 日程変更・変更回数・承認状況を追跡",
      add_log: "変更記録を追加",
      edit_log: "変更記録を編集",
      filter_all: "すべて",
      filter_pending: "承認待ち",
      filter_approved: "承認済み",
      col_order: "注文",
      col_original_date: "元の日程",
      col_new_date: "新しい日程",
      col_requested_at: "申請日時",
      col_approved_at: "承認日時",
      col_count: "変更回数",
      col_actions: "操作",
      order_id: "注文",
      original_shoot_date: "元の撮影日",
      new_shoot_date: "新しい撮影日",
      requested_at: "申請日時",
      approved_at: "承認日時",
      reason: "変更理由",
      reschedule_count: "変更回数",
      note: "メモ",
      no_logs: "変更記録がありません。",
      delete_confirm: "この変更記録を削除しますか？",
      pending_badge: "承認待ち",
      approved_badge: "承認済み",
    },
    auth: {
      login_title: "管理者ログイン",
      login_subtitle: "TaBiFoTo 管理パネル",
      email_label: "メールアドレス",
      email_placeholder: "管理者のメールアドレスを入力...",
      password_label: "パスワード",
      password_placeholder: "パスワードを入力...",
      login_button: "ログイン",
      logging_in: "確認中...",
      login_error_invalid: "メールアドレスまたはパスワードが無効です。または、アカウントが無効です。",
      login_error_supabase: "データベースが設定されていません。環境設定を確認してください。",
      login_error_network: "接続に失敗しました。再試行してください。",
      logout: "ログアウト",
      logged_in_as: "ログイン中：",
      bootstrapping: "管理パネルを読み込み中...",
      session_expired: "セッションが期限切れです。再ログインしてください。",
    },
  },
};

export default tabifotoAdmin;
